<template>


<div class="container" :class="[hide ? 'hide' : null]">
    <nav class="navbar is-transparent" role="navigation" aria-label="main navigation">


        <div class="navbar-brand">
            <router-link class="navbar-item"  :to="{name: 'home'}">
                <img :src="logo" alt="Facilimo">
            </router-link>

            <div class="burger navbar-burger has-text-info" @click="burger = !burger" :class="{'is-active':burger}">
                <i class="fa fa-bars fa-2x"></i>
            </div>
        </div>
        <div class="navbar-menu" :class="{'is-active':burger}">
            <div class="navbar-start">
                <!-- navbar items -->
            </div>

            <div class="navbar-end">
                <div class="navbar-item">
                  <div class="field il-btn">
                    <p class="control">
                      <app-incomplete-lead/>
                    </p>
                  </div>
                    <div class="field is-grouped signin-actions">
                        <p class="control">
                            <router-link class="button is-info is-outlined is-pulled-right"  :to="{name: 'signin'}" v-if="$route.name != 'signin'">
                                <i class="fa fa-user fa-lg icon" style="margin-right: 0.5rem;"></i>
                                &nbsp;Login&nbsp;
                                <i class="fa fa-long-arrow-right" style="margin-left: 0.5rem;"></i>
                            </router-link>
                        </p>
                        <p class="control">
                            <router-link class="button2 is-primary is-pulled-right"  :to="{name: 'signup'}" v-if="$route.name != 'signup'">
                                <i class="fa fa-pencil fa-lg icon" style="margin-right: 0.5rem;"></i>
                                &nbsp;Registo&nbsp;
                                <i class="fa fa-long-arrow-right" style="margin-left: 0.5rem;"></i>
                            </router-link>
                        </p>
                    </div>
                </div>
            </div>
        </div>


    </nav>
</div>






</template>

<script>
import AppIncompleteLead from "./IncompleteLead";

export default {
  components: { AppIncompleteLead },
  data() {
    return {
      burger: false,
      logo: this.$route.meta.logo,
      hide: this.$route.meta.hidehead
    };
  },
  watch: {
    "$route.name": function() {
      this.logo = this.$route.meta.logo;
      this.hide = this.$route.meta.hidehead;
    }
  }
};
</script>
<style scoped>
.hide {
  display: none;
}

.container {
  position: relative;
  padding: 1rem 0;
  z-index: 10;
}

nav,
.is-active {
  background-color: transparent;
}

a.navbar-item:hover,
a.navbar-item.is-active,
a.navbar-link:hover,
a.navbar-link.is-active {
  background-color: transparent;
  color: #2d3256;
}

.navbar-item img {
  max-height: 2.5rem;
}

.navbar-burger {
  padding: 1rem;
}

.control > .button {
  font-size: 1rem;
  padding: 1.2rem 1.2rem;
  font-weight: 700;
  margin-right: 0.75rem;
  background-color: white !important;
}

.control > .button2 {
  font-size: 1rem;
  padding: 1.2rem 1rem;
  font-weight: 700;
}

.transphead {
  background-color: white !important;
  color: #2d3256 !important;
}

/* .transphead:hover {
        background-color:white !important;
        color:#2d3256 !important;
    }*/

.button:hover {
  background-color: #2d3256 !important;
  color: white !important;
}

.button2:hover {
  background-color: white !important;
}

@media screen and (max-width: 1151px) {
  .icon {
    margin-top: 0.2rem;
  }
}

@media screen and (min-width: 1152px) {
  .il-btn {
    margin-bottom: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue